import { __awaiter } from "tslib";
import apis from '@/requests';
export const Options = {
    body: {
        user: [],
        files: [],
        type: ['#ms.required'],
        person: ['#ms.required'],
        content: ['#ms.required']
    },
    defs: {
        files: () => []
    },
    loaders: {
        create(self, done, fail, { user }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield apis.contact({
                        user,
                        type: self.type,
                        files: self.files,
                        person: self.person,
                        content: self.content
                    });
                    done();
                }
                catch (error) {
                    fail(error);
                }
            });
        }
    }
};
